import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { DataFlowNode } from './dataflow';
export var SequenceNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(SequenceNode, _DataFlowNode);

  function SequenceNode(parent, params) {
    var _this;

    _classCallCheck(this, SequenceNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SequenceNode).call(this, parent));
    _this.params = params;
    return _this;
  }

  _createClass(SequenceNode, [{
    key: "clone",
    value: function clone() {
      return new SequenceNode(null, this.params);
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign({
        type: 'sequence'
      }, this.params);
    }
  }]);

  return SequenceNode;
}(DataFlowNode);